export default __webpack_public_path__ + "static/media/iconDelete.18b58ce4.svg";